import { render, staticRenderFns } from "./activityItem.vue?vue&type=template&id=78873a64&scoped=true&"
import script from "./activityItem.vue?vue&type=script&lang=js&"
export * from "./activityItem.vue?vue&type=script&lang=js&"
import style0 from "./activityItem.vue?vue&type=style&index=0&id=78873a64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78873a64",
  null
  
)

export default component.exports